import {$, bool, datetime, Schema} from 'simpli-web-sdk'
import AuditByDeliveryCsvResponse from '@/model/response/AuditByDeliveryCsvResponse'
import * as Helpers from '@/helpers'

export default (model: AuditByDeliveryCsvResponse): Schema => ({
    idCargaPk: {
        content: model.carga && model.carga.idCargaPk,
    },

    nroNotaFiscal: {
        content: model.carga && Helpers.formatScientificNumber(model.carga.nroNotaFiscal),
    },

    dataCriacao: {
        content: model.carga && datetime(model.carga.dataCriacao),
    },

    dataBaixaSistema: {
        content: model.carga && datetime(model.carga.dataBaixaSistema),
    },

    statusAuditoria: {
        content: model.carga && model.carga.auditoriaStatus,
    },

    motivoAuditoria: {
        content: model.carga && model.carga.auditoria && model.carga.auditoria.motivo &&
            model.carga.auditoria.motivo.nome ? model.carga.auditoria.motivo.nome :
            $.tc('classes.AuditByDeliveryCsvResponse.columns.notAudited'),
    },

    statusNotificacaoAuditoria: {
        content: model.carga && model.carga.cargaInfo && model.carga.cargaInfo.statusNotificacaoAuditoria &&
            model.carga.cargaInfo.statusNotificacaoAuditoria.nome ?
            model.carga.cargaInfo.statusNotificacaoAuditoria.nome :
            $.tc('classes.AuditByDeliveryCsvResponse.columns.notNotified'),
    },

    nomeGrupo: {
        content: model.emailAuditoriaEnvio && model.emailAuditoriaEnvio.nomeGrupo ?
            model.emailAuditoriaEnvio.nomeGrupo : $.tc('classes.AuditByDeliveryCsvResponse.columns.notNotified'),
    },

    emailEnviado: {
        content: model.emailEnviado,
    },

    dataEnvio: {
        content: model.emailAuditoriaEnvio && model.emailAuditoriaEnvio.dataEnvio ?
            datetime(model.emailAuditoriaEnvio.dataEnvio) :
            $.tc('classes.AuditByDeliveryCsvResponse.columns.notNotified'),
    },
})
